import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, LogOut, Shield, ShoppingCart, ShoppingBag, Download } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-30 border-b border-zinc-800 bg-[#0a0a0c]/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="h-6 w-1.5 rounded-full bg-[#ff2a5f]" />
          <span className="font-display text-xl font-extrabold uppercase tracking-tight text-white">
            MX Portal
          </span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-3">
          <Link to="/" data-testid="nav-store" className="hidden text-sm font-medium text-zinc-400 hover:text-white sm:block px-3 py-2">
            Store
          </Link>
          <button data-testid="nav-cart" onClick={() => navigate("/checkout")} className="relative rounded-lg p-2 text-zinc-300 hover:bg-zinc-800 hover:text-white">
            <ShoppingCart className="h-5 w-5" />
            {count > 0 && <span data-testid="cart-count" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#ff2a5f] px-1 text-[10px] font-bold text-white">{count}</span>}
          </button>
          {user && user.role === "admin" && (
            <Button data-testid="nav-admin" variant="ghost" onClick={() => navigate("/admin")} className="text-zinc-300 hover:text-white">
              <Shield className="mr-1.5 h-4 w-4" /> Admin
            </Button>
          )}
          {user && user.role === "customer" && (
            <>
              <Button data-testid="nav-orders" variant="ghost" onClick={() => navigate("/dashboard")} className="text-zinc-300 hover:text-white">
                <ShoppingBag className="mr-1.5 h-4 w-4" /> My Orders
              </Button>
              <Button data-testid="nav-downloads" variant="ghost" onClick={() => navigate("/downloads")} className="text-zinc-300 hover:text-white">
                <Download className="mr-1.5 h-4 w-4" /> My Downloads
              </Button>
            </>
          )}
          {user && user.role ? (
            <>
              <Button
                data-testid="nav-logout"
                variant="outline"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="border-zinc-700 bg-transparent text-zinc-300 hover:bg-zinc-800 hover:text-white"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button
              data-testid="nav-login"
              onClick={() => navigate("/login")}
              className="bg-[#ff2a5f] font-semibold text-white hover:bg-[#e01f50]"
            >
              Sign in
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
}
